import { render, staticRenderFns } from "./ComplieChildMenuBorder.vue?vue&type=template&id=0976591a&scoped=true"
import script from "./ComplieChildMenuBorder.vue?vue&type=script&lang=js"
export * from "./ComplieChildMenuBorder.vue?vue&type=script&lang=js"
import style0 from "./ComplieChildMenuBorder.vue?vue&type=style&index=0&id=0976591a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976591a",
  null
  
)

export default component.exports